import useMainStore from '@/composables/use-main-store';
import Privilege from '@/enums/privilege';

const hasAnyPrivilege = (privilegesToCheck: Privilege[]): boolean => {
    const { privileges } = useMainStore();

    if (!privilegesToCheck.length) {
        return true;
    }

    return privilegesToCheck.some((privilege: Privilege): boolean => privileges.value?.includes(privilege) || false);
};

export { hasAnyPrivilege };
